// extracted by mini-css-extract-plugin
export default {"invoiceLine":"TeamMembersSeatsWidget_invoiceLine__7pGEd"};